import { AmplifyModules } from 'aws-amplify-angular';
import Auth from '@aws-amplify/auth';
var ɵ0 = function () {
    return AmplifyModules({
        Auth: Auth
    });
};
var LoginModule = /** @class */ (function () {
    function LoginModule() {
    }
    return LoginModule;
}());
export { LoginModule };
export { ɵ0 };



// WEBPACK FOOTER //
// ./src/app/login/login.module.ts.pre-build-optimizer.js